module.exports = __webpack_public_path__ + "img/xny_bd.a63381a.png";